import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/layout";
import Mobile from "@/layout/mobile.vue";

export const constantRoutes = [
  // 循环打印页面
  {
    path: "/utilsAll",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/utilsAll",
        name: "utilsAll",
        component: () => import("@/components/utils/index.vue"),
        meta: { title: "自动导出、上传页面汇总", icon: "" }
      }
    ]
  },
  {
    path: "/playerDetailPrintAuto",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/playerDetailPrintAuto",
        name: "playerDetailPrintAuto",
        component: () => import("@/components/utils/playerDetailPrintAuto.vue"),
        meta: { title: "运动员档案打印", icon: "" }
      }
    ]
  },
  {
    path: "/monitorDailyReportPrintAuto",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/monitorDailyReportPrintAuto",
        name: "monitorDailyReportPrintAuto",
        component: () =>
          import("@/components/utils/monitorDailyReportPrintAuto.vue"),
        meta: { title: "机能日常报告打印", icon: "" }
      }
    ]
  },
  {
    path: "/assessmentCollectionPrintAuto",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/assessmentCollectionPrintAuto",
        name: "assessmentCollectionPrintAuto",
        component: () =>
          import("@/components/utils/assessmentCollectionPrintAuto.vue"),
        meta: { title: "大纲考核汇总报告打印", icon: "" }
      }
    ]
  },
  {
    path: "/planPrintAuto",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/planPrintAuto",
        name: "planPrintAuto",
        component: () => import("@/components/utils/planPrintAuto.vue"),
        meta: { title: "训练计划打印", icon: "" }
      }
    ]
  },
  {
    path: "/moralityEducationPrintAuto",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/moralityEducationPrintAuto",
        name: "moralityEducationPrintAuto",
        component: () =>
          import("@/components/utils/moralityEducationPrintAuto.vue"),
        meta: { title: "德育教育打印", icon: "" }
      }
    ]
  },
  {
    path: "/empDetailPrintAuto",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/empDetailPrintAuto",
        name: "empDetailPrintAuto",
        component: () => import("@/components/utils/empDetailPrintAuto.vue"),
        meta: { title: "教练员档案打印", icon: "" }
      }
    ]
  },
  {
    path: "/copyPlanDoc",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/copyPlanDoc",
        name: "copyPlanDoc",
        component: () => import("@/components/utils/copyPlanDoc.vue"),
        meta: { title: "训练计划同步", icon: "" }
      }
    ]
  },
  {
    path: "/uploadCultureScore",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/uploadCultureScore",
        name: "uploadCultureScore",
        component: () => import("@/components/utils/uploadCultureScore.vue"),
        meta: { title: "文化成绩上传", icon: "" }
      }
    ]
  },
  {
    path: "/uploadMetaData2",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/uploadMetaData2",
        name: "uploadMetaData2",
        component: () => import("@/components/utils/uploadMetaData2.vue"),
        meta: { title: "大纲考核指标上传", icon: "" }
      }
    ]
  },
  {
    path: "/uploadAssessmentData",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/uploadAssessmentData",
        name: "uploadAssessmentData",
        component: () => import("@/components/utils/uploadAssessmentData.vue"),
        meta: { title: "大纲考核数据上传", icon: "" }
      }
    ]
  },
  {
    path: "/uploadniaochanggui",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/uploadniaochanggui",
        name: "uploadniaochanggui",
        component: () => import("@/components/utils/uploadniaochanggui.vue"),
        meta: { title: "尿常规数据上传", icon: "" }
      }
    ]
  },
  {
    path: "/uploadPerson",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/uploadPerson",
        name: "uploadPerson",
        component: () => import("@/components/utils/uploadPerson.vue"),
        meta: { title: "人员模板数据上传", icon: "" }
      }
    ]
  },
  {
    path: "/uploadMatch",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/uploadMatch",
        name: "uploadMatch",
        component: () => import("@/components/utils/uploadMatch.vue"),
        meta: { title: "比赛成绩数据上传", icon: "" }
      }
    ]
  },
  {
    path: "/uploadTransport",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/uploadTransport",
        name: "uploadTransport",
        component: () => import("@/components/utils/uploadTransport.vue"),
        meta: { title: "走向输送上传", icon: "" }
      }
    ]
  },
  {
    path: "/downloadCsv",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/downloadCsv",
        name: "downloadCsv",
        component: () => import("@/components/utils/downloadCsv.vue"),
        meta: { title: "大纲考核下载", icon: "" }
      }
    ]
  },
  {
    path: "/genFakeData",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/genFakeData",
        name: "genFakeData",
        component: () => import("@/components/utils/genFakeData.vue"),
        meta: { title: "大纲数据生成", icon: "" }
      }
    ]
  },
  {
    path: "/uploadInjuryRecord",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/uploadInjuryRecord",
        name: "uploadInjuryRecord",
        component: () => import("@/components/utils/uploadInjuryRecord.vue"),
        meta: { title: "伤病管理上传", icon: "" }
      }
    ]
  },

  // 公用路由
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },

  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true
  },
  {
    path: "/",
    component: Layout, //此页面是否有头部和侧边栏
    hidden: true, //此页面导航是否不显示在侧边栏
    redirect: "/dashboard", //页面重定向地址
    children: [
      {
        path: "/dashboard", //页面地址
        name: "Dashboard",
        component: () => import("@/views/dashboard/index"),
        meta: { title: "主页", icon: "dashboard" }
      }
    ]
  },
  {
    path: "/personInsert",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/personInsert",
        name: "personInsert",
        component: () => import("@/components/person/personInsert.vue"),
        meta: { title: "新增", icon: "" },
        beforeEnter: (to, from, next) => {
          if (
            window.sessionStorage.getItem("isPlayer") &&
            (from.path === "/person/player/referPlayer" ||
              from.path === "/staff/allEmployee")
          ) {
            next();
          } else {
            router.back();
            next();
          }
        }
      }
    ]
  },
  {
    path: "/empDetail",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/empDetail",
        name: "empDetail",
        component: () => import("@/views/employee/empDetail.vue"),
        meta: { title: "教职员建档", icon: "" }
      }
    ]
  },
  {
    path: "/playerDetail",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/playerDetail",
        name: "playerDetail",
        component: () => import("@/views/player/playerDetail.vue"),
        meta: { title: "运动员建档", icon: "" }
      }
    ]
  },
  {
    path: "/TrainingPlan",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/TrainingPlan",
        name: "TrainingPlan",
        component: () => import("@/views/plan/planCreate/TrainingPlan.vue"),
        meta: { title: "训练计划编辑", icon: "" }
      }
    ]
  },
  {
    path: "/weekPlanCreateAndPreview",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/weekPlanCreateAndPreview",
        name: "weekPlanCreateAndPreview",
        component: () =>
          import("@/views/plan/planCreate/weekPlanCreateAndPreview.vue"),
        meta: { title: "周训练计划编辑", icon: "" }
      }
    ]
  },

  {
    path: "/classPlanCreateAndPreview",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/classPlanCreateAndPreview",
        name: "classPlanCreateAndPreview",
        component: () =>
          import("@/views/plan/planCreate/classPlanCreateAndPreview.vue"),
        meta: { title: "课时训练计划编辑", icon: "" }
      }
    ]
  },
  {
    path: "/docExcelPrint",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/docExcelPrint",
        name: "docExcelPrint",
        component: () => import("@/components/print/docExcelPrint.vue"),
        meta: { title: "阶段训练计划表打印预览", icon: "" }
      }
    ]
  },
  {
    path: "/assistant/viewAssistant",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/assistant/viewAssistant",
        name: "viewAssistant",
        component: () => import("@/views/assistant/assistant.vue"),
        meta: { title: "帮助", icon: "" }
      }
    ]
  },
  {
    path: "/meta/page/viewAttr",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/meta/page/viewAttr",
        name: "viewAttr",
        component: () => import("@/views/assistant/viewAttr.vue"),
        meta: { title: "个人档案", icon: "" }
      }
    ]
  },
  // -------

  // 404 page must be placed at the end !!!
  { path: "*", redirect: "/404", hidden: true }
];

// 三级和四级菜单路由动态路由

export const asyncRouters = [
  // 二级菜单路由
  {
    path: "/orgConfig/policyConfig",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/orgConfig/policyConfig",
        name: "policyConfig",
        component: () => import("@/views/organization/policyConfig.vue"),
        meta: { title: "权限管理", icon: "", role: [2] }
      }
    ]
  },
  {
    path: "/center/viewConfig",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/center/viewConfig",
        name: "centerConfig",
        component: () => import("@/views/organization/centerConfig.vue"),
        meta: { title: "训练中心管理", icon: "", role: [2] }
      }
    ]
  },
  {
    path: "/organization/base_info/view",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/organization/base_info/view",
        name: "orgInfo",
        component: () => import("@/views/organization/orgInfo.vue"),
        meta: { title: "机构信息", icon: "", role: [2] }
      }
    ]
  },
  {
    path: "/base/view",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/base/view",
        name: "baseData",
        component: () => import("@/views/organization/baseData.vue"),
        meta: { title: "基地建设", icon: "", role: [2] }
      }
    ]
  },
  {
    path: "/organization/SportsSchoolQuestionnaire",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/organization/SportsSchoolQuestionnaire",
        name: "baseData",
        component: () =>
          import("@/views/organization/SportsSchoolQuestionnaire1.vue"),
        meta: { title: "各级各类体校调查统计表", icon: "", role: [2] }
      }
    ]
  },
  {
    path: "/medical/comprehensiveAssessment",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/medical/comprehensiveAssessment",
        name: "medical",
        component: () =>
          import("@/views/science/medical/comprehensiveAssessment.vue"),
        meta: { title: "综合分析评价", icon: "", role: [2] }
      }
    ]
  },
  {
    path: "/organization/DocumentNotification",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/organization/DocumentNotification",
        name: "baseData",
        component: () =>
          import("@/views/organization/DocumentNotification.vue"),
        meta: { title: "年度信息填报", icon: "", role: [2] }
      }
    ]
  },
  {
    path: "/nourishment/index",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/nourishment/index",
        name: "baseData",
        component: () => import("@/views/nourishment/index.vue"),
        meta: { title: "营养品/药品", icon: "", role: [2] }
      }
    ]
  },
  {
    path: "/nourishment/Summary",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/nourishment/Summary",
        name: "baseData",
        component: () => import("@/views/nourishment/Summary.vue"),
        meta: { title: "出入库记录汇总", icon: "", role: [2] }
      }
    ]
  },
  {
    path: "/meta/player_coach_map/viewProportion",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/meta/player_coach_map/viewProportion",
        name: "player_coach_map",
        component: () => import("@/views/organization/proprotion.vue"),
        meta: { title: "师生比", icon: "", role: [2] }
      }
    ]
  },
  {
    path: "/organization/baseCheckSummary",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/organization/baseCheckSummary",
        name: "baseCheckSummary",
        component: () => import("@/views/organization/baseCheckSummary.vue"),
        meta: { title: "2021国家基地评估", icon: "", role: [2] }
      }
    ]
  },
  {
    path: "/staff/allEmployee",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/staff/allEmployee",
        name: "referEmployee",
        component: () => import("@/views/employee/referEmployee.vue"),
        meta: { title: "教职员查询", icon: "" }
      }
    ]
  },
  {
    path: "/person/player/referPlayer",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/person/player/referPlayer",
        name: "referPlayer",
        component: () => import("@/views/player/referPlayer.vue"),
        meta: { title: "运动员查询", icon: "" }
      }
    ]
  },
  {
    path: "/player_attendance/view",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/player_attendance/view",
        name: "playerAttendance",
        component: () => import("@/views/player/playerAttendance.vue"),
        meta: { title: "运动员考勤", icon: "" }
      }
    ]
  },
  {
    path: "/process/viewPlayerStatusApply",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/process/viewPlayerStatusApply",
        name: "playerStatusApply",
        component: () => import("@/views/player/playerStatusApply.vue"),
        meta: { title: "进退队申请", icon: "" }
      }
    ]
  },
  {
    path: "/process/viewPlayerStatusAccept",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/process/viewPlayerStatusAccept",
        name: "playerStatusAccept",
        component: () => import("@/views/player/playerStatusAccept.vue"),
        meta: { title: "进退队审核", icon: "" }
      }
    ]
  },
  {
    path: "/staff/empBasicInfo",
    component: Layout,
    redirect: "/staff/empCreate",
    name: "empBaseInfo",
    meta: { title: "基本信息", icon: "form" },
    children: [
      {
        path: "  ",
        name: "empCreate",
        component: () => import("@/views/employee/empBaseInfo/empCreate.vue"),
        meta: { title: "教职员建档", icon: "table" }
      },
      {
        path: "/staff/empIdentity",
        name: "empIdentity",
        component: () => import("@/views/employee/empBaseInfo/empIdentity.vue"),
        meta: { title: "身份信息", icon: "table" }
      },
      {
        path: "/staff/empBasicInfo",
        name: "empBasicInfo",
        component: () =>
          import("@/views/employee/empBaseInfo/empBasicInfo.vue"),
        meta: { title: "基本信息", icon: "table" }
      },
      {
        path: "/staff/empForeignLang",
        name: "empForeignLang",
        component: () =>
          import("@/views/employee/empBaseInfo/empForeignLang.vue"),
        meta: { title: "外语水平", icon: "table" }
      },
      {
        path: "/staff/empWorkExp",
        name: "empWorkExp",
        component: () => import("@/views/employee/empBaseInfo/empWorkExp.vue"),
        meta: { title: "任职经历", icon: "table" }
      },
      {
        path: "/staff/empEdu",
        name: "empEdu",
        component: () => import("@/views/employee/empBaseInfo/empEdu.vue"),
        meta: { title: "教育经历", icon: "table" }
      },
      {
        path: "/staff/playerRecords",
        name: "playerRecords",
        component: () => import("@/views/player/playerRecords.vue"),
        meta: { title: "运动员记录", icon: "table" }
      }
    ]
  },
  {
    path: "/staff/empBasicInfo/postInfo",
    component: Layout,
    redirect: "/staff/empJoin",
    name: "postInfo",
    meta: { title: "职务信息", icon: "form" },
    children: [
      {
        path: "/staff/empJoin",
        name: "empJoin",
        component: () => import("@/views/employee/empBaseInfo/empJoin.vue"),
        meta: { title: "入职信息", icon: "table" }
      },
      {
        path: "/staff/coachAndplayer",
        name: "coachAndplayer",
        component: () =>
          import("@/views/employee/empBaseInfo/coachAndplayer.vue"),
        meta: { title: "教练员与运动员", icon: "table" }
      }
    ]
  },
  {
    path: "/staff/empBasicInfo/sportInfo",
    component: Layout,
    redirect: "/staff/sportRank",
    name: "sportInfo",
    meta: { title: "运动情况", icon: "form" },
    children: [
      {
        path: "/staff/sportRank",
        name: "sportRank",
        component: () => import("@/views/employee/empBaseInfo/sportRank.vue"),
        meta: { title: "运动等级", icon: "table" }
      },
      {
        path: "/staff/coachRank",
        name: "coachRank",
        component: () => import("@/views/employee/empBaseInfo/coachRank.vue"),
        meta: { title: "裁判等级", icon: "table" }
      },
      {
        path: "/staff/rewardPunishment",
        name: "rewardPunishment",
        component: () =>
          import("@/views/employee/empBaseInfo/rewardPunishment.vue"),
        meta: { title: "奖罚情况", icon: "table" }
      }
    ]
  },
  {
    path: "/staff/empBasicInfo/talents",
    component: Layout,
    redirect: "/staff/jobRank",
    name: "talents",
    meta: { title: "人才质量/效益", icon: "form" },
    children: [
      {
        path: "/staff/jobRank",
        name: "jobRank",
        component: () => import("@/views/employee/empBaseInfo/jobRank.vue"),
        meta: { title: "职称等级", icon: "table" }
      },
      {
        path: "/staff/furtherEdu",
        name: "furtherEdu",
        component: () => import("@/views/employee/empBaseInfo/furtherEdu.vue"),
        meta: { title: "进修培训", icon: "table" }
      },
      {
        path: "/staff/academicPapers",
        name: "academicPapers",
        component: () =>
          import("@/views/employee/empBaseInfo/academicPapers.vue"),
        meta: { title: "学术论文著作", icon: "table" }
      },
      {
        path: "/staff/empEduStatus",
        name: "empEduStatus",
        component: () =>
          import("@/views/employee/empBaseInfo/empEduStatus.vue"),
        meta: { title: "学历统计", icon: "table" }
      }
    ]
  },
  {
    path: "/person/player/basicSituation",
    component: Layout,
    redirect: "/person/player/createPlayer",
    name: "playerBaseInfo",
    meta: { title: "基本信息", icon: "form" },
    children: [
      {
        path: "/person/player/createPlayer",
        name: "playerCreate",
        component: () =>
          import("@/views/player/playerBaseInfo/playerCreate.vue"),
        meta: { title: "运动员建档", icon: "table" }
      },
      {
        path: "/player/identity",
        name: "playerIdentity",
        component: () =>
          import("@/views/player/playerBaseInfo/playerIdentity.vue"),
        meta: { title: "身份信息", icon: "table" }
      },
      {
        path: "/person/player/basicSituation",
        name: "playerBasicSituation",
        component: () =>
          import("@/views/player/playerBaseInfo/playerBasicSituation.vue"),
        meta: { title: "基本信息", icon: "table" }
      },
      {
        path: "/person/player/joinTeam",
        name: "joinTeam",
        component: () => import("@/views/player/playerBaseInfo/joinTeam.vue"),
        meta: { title: "入队信息", icon: "table" }
      },
      {
        path: "/person/player/family",
        name: "playerFamily",
        component: () =>
          import("@/views/player/playerBaseInfo/playerFamily.vue"),
        meta: { title: "家庭成员", icon: "table" }
      },
      {
        path: "/person/player/eduExp",
        name: "playerEdu",
        component: () => import("@/views/player/playerBaseInfo/playerEdu.vue"),
        meta: { title: "教育经历", icon: "table" }
      },
      {
        path: "/person/player/studentStatus",
        name: "studentStatus",
        component: () =>
          import("@/views/player/playerBaseInfo/studentStatus.vue"),
        meta: { title: "学籍情况", icon: "table" }
      },
      {
        path: "/person/player/rewardAndPunishment",
        name: "rewardAndPunishment",
        component: () =>
          import("@/views/player/playerBaseInfo/rewardAndPunishment.vue"),
        meta: { title: "奖惩情况", icon: "table" }
      },
      {
        path: "/player_important_map/view",
        name: "playerImportantMap",
        component: () =>
          import("@/views/player/playerBaseInfo/playerImportantMap.vue"),
        meta: { title: "重点运动员名单", icon: "table" }
      }
    ]
  },
  {
    path: "/player/playerSportInfo",
    component: Layout,
    redirect: "/person/player/sportRank",
    name: "playerSportInfo",
    meta: { title: "运动情况", icon: "form" },
    children: [
      {
        path: "/person/player/sportRank",
        name: "playerSportRank",
        component: () => import("@/views/player/playerBaseInfo/sportRank.vue"),
        meta: { title: "运动等级", icon: "table" }
      },
      {
        path: "/person/player/sportResume",
        name: "sportResume",
        component: () =>
          import("@/views/player/playerBaseInfo/sportResume.vue"),
        meta: { title: "运动简历", icon: "table" }
      },
      {
        path: "/person/player/trainingSituation",
        name: "trainingSituation",
        component: () =>
          import("@/views/player/playerBaseInfo/trainingSituation.vue"),
        meta: { title: "上级单位集训试训", icon: "table" }
      }
    ]
  },
  {
    path: "/player/daily",
    component: Layout,
    alwaysShow: true,
    redirect: "/person/player/dorm",
    name: "daily",
    meta: { title: "日常管理", icon: "form" },
    children: [
      {
        path: "/person/player/dorm",
        name: "dorm",
        component: () => import("@/views/player/playerBaseInfo/dorm.vue"),
        meta: { title: "宿舍管理", icon: "table" }
      }
    ]
  },
  {
    path: "/player/playerTalents",
    component: Layout,
    redirect: "/person/player/matchScore",
    name: "playerTalents",
    meta: { title: "人才质量/效益", icon: "form" },
    children: [
      {
        path: "/person/player/matchScore",
        name: "matchScore",
        component: () => import("@/views/player/playerBaseInfo/matchScore.vue"),
        meta: { title: "比赛成绩", icon: "table" }
      },
      {
        path: "/person/player/matchScore_jina",
        name: "matchScore_jina",
        component: () =>
          import("@/views/player/playerBaseInfo/matchScore_jina.vue"),
        meta: { title: "比赛成绩简录", icon: "table" }
      },
      {
        path: "/person/player/transmission",
        name: "transmission",
        component: () =>
          import("@/views/player/playerBaseInfo/transmission.vue"),
        meta: { title: "走向/输送", icon: "table" }
      },
      {
        path: "/person/player/injure",
        name: "playerInjure",
        component: () =>
          import("@/views/player/playerBaseInfo/playerInjure.vue"),
        meta: { title: "伤病管理", icon: "table" }
      },
      {
        path: "/person/player/cultureScore",
        name: "cultureScore",
        component: () =>
          import("@/views/player/playerBaseInfo/cultureScore.vue"),
        meta: { title: "文化成绩管理", icon: "table" }
      }
    ]
  },
  // 训练计划
  {
    path: "/assistant/viewAssistant4Training",
    component: Layout,
    hidden: true,
    redirect: "/assistant/viewAssistant4Training",
    name: "planCreate",
    meta: { title: "训练计划撰写", icon: "form" },
    children: [
      {
        path: "/assistant/viewAssistant4Training",
        name: "assistant4Training",
        component: () =>
          import("@/views/plan/planCreate/assistant4Training.vue"),
        meta: { title: "训练计划", icon: "table" }
      }
    ]
  },
  // ... existing code ...
  {
    path: "/assistant/weekPlan",
    component: Layout,
    alwaysShow: true,
    redirect: "/trainPlan/WeekPlan",
    name: "assistant",
    meta: { title: "训练教案", icon: "el-icon-s-claim", vipHideFor: "no-vip" },
    children: [
      {
        path: "/trainPlan/WeekPlan",
        name: "weekPlan",
        component: () => import("@/views/plan/planCreate/weekPlan.vue"),
        meta: {
          title: "周训练计划",
          icon: "el-icon-edit-outline",
          vipHideFor: "no-vip"
        }
      }
    ]
  },

  // ... existing code ...
  {
    path: "/assistant/fullYearPlan",
    component: Layout,
    alwaysShow: true,
    redirect: "/trainPlan/viewFullYearPlan",
    name: "",
    meta: {
      title: "全年计划及总结",
      icon: "el-icon-s-claim"
    },
    children: [
      {
        path: "/trainPlan/viewFullYearPlan",
        name: "fullYearPlan",
        component: () => import("@/views/plan/planCreate/fullYearPlan.vue"),
        meta: {
          title: "全年训练计划",
          icon: "el-icon-edit-outline",
          vipHideFor: "no-vip"
        }
      },
      {
        path: "/trainPlan/viewTrainPlanExcelMk",
        name: "trainPlanExcelMk",
        component: () => import("@/views/plan/planCreate/trainPlanExcelMk.vue"),
        meta: {
          title: "阶段训练计划表",
          icon: "el-icon-edit-outline",
          vipHideFor: "no-vip"
        }
      },
      {
        path: "/trainPlan/viewPeriodPlan",
        name: "periodPlan",
        component: () => import("@/views/plan/planCreate/periodPlan.vue"),
        meta: {
          title: "阶段训练计划",
          icon: "el-icon-edit-outline",
          vipHideFor: "no-vip"
        }
      },
      {
        path: "/trainPlan/viewFullYearSummary",
        name: "fullYearSummary",
        component: () => import("@/views/plan/planCreate/fullYearSummary.vue"),
        meta: {
          title: "全年训练总结",
          icon: "el-icon-edit-outline",
          vipHideFor: "no-vip"
        }
      }
    ]
  },

  {
    path: "/assistant/multiYearPlan",
    component: Layout,
    alwaysShow: true,
    redirect: "/multiYearPlan",
    name: "",
    meta: { title: "常规管理", icon: "form" },
    children: [
      {
        path: "/trainPlan/viewWinterPeriodPlan",
        name: "winterPeriodPlan",
        component: () => import("@/views/plan/planCreate/winterPeriodPlan.vue"),
        meta: { title: "冬训阶段计划", icon: "el-icon-edit-outline" }
      },
      {
        path: "/trainPlan/viewWinterSummary",
        name: "winterSummary",
        component: () => import("@/views/plan/planCreate/winterSummary.vue"),
        meta: { title: "冬训小结", icon: "el-icon-edit-outline" }
      },
      {
        path: "/trainPlan/viewPre_MatchPlan",
        name: "pre_MatchPlan",
        component: () => import("@/views/plan/planCreate/pre_MatchPlan.vue"),
        meta: { title: "赛前阶段训练计划", icon: "el-icon-edit-outline" }
      },
      {
        path: "/trainPlan/viewMatchSummary",
        name: "matchSummary",
        component: () => import("@/views/plan/planCreate/matchSummary.vue"),
        meta: {
          title: "比赛小结",
          icon: "el-icon-edit-outline",
          vipHideFor: "no-vip"
        }
      },
      {
        path: "/trainPlan/viewYearMatchSummary",
        name: "yearMatchSummary",
        component: () => import("@/views/plan/planCreate/yearMatchSummary.vue"),
        meta: {
          title: "年度比赛总结",
          icon: "el-icon-edit-outline",
          vipHideFor: "no-vip"
        }
      },
      {
        path: "/trainPlan/viewMatchScheme",
        name: "matchScheme",
        component: () => import("@/views/plan/planCreate/matchScheme.vue"),
        meta: {
          title: "参赛预案",
          icon: "el-icon-edit-outline",
          vipHideFor: "no-vip"
        }
      },
      {
        path: "/trainPlan/viewMultiYearPlan",
        name: "multiYearPlan",
        component: () => import("@/views/plan/planCreate/multiYearPlan.vue"),
        meta: { title: "多年训练计划", icon: "el-icon-edit-outline" }
      },
      {
        path: "/trainPlan/viewYearPaper",
        name: "yearPaper",
        component: () => import("@/views/plan/planCreate/yearPaper.vue"),
        meta: { title: "年度专业研究论文", icon: "el-icon-edit-outline" }
      }
    ]
  },

  {
    path: "/trainPlan/view",
    component: Layout,
    hidden: true,
    redirect: "/trainPlan/view",
    name: "",
    meta: { title: "训练计划查看", icon: "form" },
    children: [
      {
        path: "/trainPlan/view",
        name: "trainPlan",
        component: () => import("@/views/plan/trainPlan/trainPlan.vue"),
        meta: { title: "文档查看及修改", icon: "table" }
      }
    ]
  },
  {
    path: "/TrainingPlanFree/view",
    component: Layout,
    hidden: true,
    redirect: "/TrainingPlanFree/view",
    name: "",
    meta: { title: "训练计划（免费版）", icon: "form" },
    children: [
      {
        path: "/TrainingPlanFree/view",
        name: "TrainingPlanFree",
        component: () => import("@/views/plan/TrainingPlanFree/index.vue"),
        meta: { title: "训练计划（免费版）", icon: "table" }
      }
    ]
  },
  {
    path: "/trainPlan/View",
    component: Layout,
    alwaysShow: true,
    redirect: "/trainPlan/weekPlan",
    name: "",
    meta: { title: "训练教案", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/trainPlan/weekPlan",
        name: "weekPlanView",
        component: () => import("@/views/plan/planCreate/weekPlan.vue"),
        meta: { title: "周训练计划", icon: "el-icon-date" }
      }
    ]
  },

  //全年计划及总结训练计划查看
  {
    path: "/trainPlan/fullYearPlanView",
    component: Layout,
    alwaysShow: true,
    redirect: "/trainPlan/fullYearPlan",
    name: "",
    meta: {
      title: "全年计划及总结",
      icon: "el-icon-s-claim"
    },
    children: [
      {
        path: "/trainPlan/fullYearPlan",
        name: "fullYearPlan",
        component: () => import("@/views/plan/trainPlan/fullYearPlan.vue"),
        meta: { title: "全年训练计划", icon: "el-icon-date" }
      },
      {
        path: "/trainPlan/periodPlanExcel",
        name: "periodPlanExcelView",
        component: () => import("@/views/plan/trainPlan/periodPlanExcel.vue"),
        meta: { title: "阶段训练计划表", icon: "el-icon-date" }
      },
      {
        path: "/trainPlan/periodPlan",
        name: "periodPlanView",
        component: () => import("@/views/plan/trainPlan/periodPlan.vue"),
        meta: { title: "阶段训练计划", icon: "el-icon-date" }
      },
      {
        path: "/trainPlan/fullYearSummary",
        name: "fullYearSummaryView",
        component: () => import("@/views/plan/trainPlan/fullYearSummary.vue"),
        meta: { title: "全年训练总结", icon: "el-icon-date" }
      }
    ]
  },

  {
    path: "/trainPlan/winterPeriodPlanView",
    component: Layout,
    alwaysShow: true,
    redirect: "/trainPlan/winterPeriodPlan",
    name: "",
    meta: { title: "常规管理", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/trainPlan/winterPeriodPlan",
        name: "winterPeriodPlanView",
        component: () => import("@/views/plan/trainPlan/winterPeriodPlan.vue"),
        meta: { title: "冬训阶段计划", icon: "el-icon-date" }
      },
      {
        path: "/trainPlan/winterSummary",
        name: "winterSummaryView",
        component: () => import("@/views/plan/trainPlan/winterSummary.vue"),
        meta: { title: "冬训小结", icon: "el-icon-date" }
      },
      {
        path: "/trainPlan/pre_MatchPlan",
        name: "pre_MatchPlanView",
        component: () => import("@/views/plan/trainPlan/pre_MatchPlan.vue"),
        meta: { title: "赛前阶段计划", icon: "el-icon-date" }
      },
      {
        path: "/trainPlan/matchSummary",
        name: "matchSummaryView",
        component: () => import("@/views/plan/trainPlan/matchSummary.vue"),
        meta: { title: "比赛小结", icon: "el-icon-date" }
      },
      {
        path: "/trainPlan/yearMatchSummary",
        name: "yearMatchSummaryView",
        component: () => import("@/views/plan/trainPlan/yearMatchSummary.vue"),
        meta: { title: "年度比赛总结", icon: "el-icon-date" }
      },
      {
        path: "/trainPlan/matchScheme",
        name: "matchSchemeView",
        component: () => import("@/views/plan/trainPlan/matchScheme.vue"),
        meta: { title: "参赛预案", icon: "el-icon-date" }
      },
      {
        path: "/trainPlan/multiYearPlan",
        name: "multiYearPlanView",
        component: () => import("@/views/plan/trainPlan/multiYearPlan.vue"),
        meta: { title: "多年训练计划", icon: "el-icon-date" }
      },
      {
        path: "/trainPlan/yearPaper",
        name: "yearPaperView",
        component: () => import("@/views/plan/trainPlan/yearPaper.vue"),
        meta: { title: "年度专业研究论文", icon: "el-icon-date" }
      }
    ]
  },
  //常规管理查看免费版
  // {
  //   path: "/trainPlan/winterPeriodPlanView1",
  //   component: Layout,
  //   alwaysShow: true,
  //   redirect: "/trainPlan/winterPeriodPlan",
  //   name: "",
  //   meta: { title: "常规管理", icon: "el-icon-s-claim", vipHideFor: "vip" },
  //   children: [
  //     {
  //       path: "/trainPlan/winterPeriodPlan",
  //       name: "winterPeriodPlanView",
  //       component: () => import("@/views/plan/trainPlan/winterPeriodPlan.vue"),
  //       meta: { title: "冬训阶段计划", icon: "el-icon-date" }
  //     },
  //     {
  //       path: "/trainPlan/winterSummary",
  //       name: "winterSummaryView",
  //       component: () => import("@/views/plan/trainPlan/winterSummary.vue"),
  //       meta: { title: "冬训小结", icon: "el-icon-date" }
  //     },
  //     {
  //       path: "/trainPlan/pre_MatchPlan",
  //       name: "pre_MatchPlanView",
  //       component: () => import("@/views/plan/trainPlan/pre_MatchPlan.vue"),
  //       meta: { title: "赛前阶段计划", icon: "el-icon-date" }
  //     },
  //     {
  //       path: "/trainPlan/matchSummary",
  //       name: "matchSummaryView",
  //       component: () => import("@/views/plan/trainPlan/matchSummary.vue"),
  //       meta: { title: "比赛小结", icon: "el-icon-date" }
  //     },
  //     {
  //       path: "/trainPlan/yearMatchSummaryFree",
  //       name: "yearMatchSummaryFree",
  //       component: () =>
  //         import("@/views/plan/trainPlan/yearMatchSummaryFree.vue"),
  //       meta: { title: "年度比赛总结（免费版）", icon: "el-icon-date" }
  //     },
  //     {
  //       path: "/trainPlan/matchSchemeFree",
  //       name: "matchSchemeFree",
  //       component: () => import("@/views/plan/trainPlan/matchSchemeFree.vue"),
  //       meta: { title: "参赛预案(免费版)", icon: "el-icon-date" }
  //     },
  //     {
  //       path: "/trainPlan/multiYearPlan",
  //       name: "multiYearPlanView",
  //       component: () => import("@/views/plan/trainPlan/multiYearPlan.vue"),
  //       meta: { title: "多年训练计划", icon: "el-icon-date" }
  //     },
  //     {
  //       path: "/trainPlan/yearPaper",
  //       name: "yearPaperView",
  //       component: () => import("@/views/plan/trainPlan/yearPaper.vue"),
  //       meta: { title: "年度专业研究论文", icon: "el-icon-date" }
  //     }
  //   ]
  // },
  // 科学选材
  {
    path: "/medical/selection",
    component: Layout,
    alwaysShow: true,
    redirect: "/medical/selection/massInput",
    name: "selection",
    meta: { title: "选材报告管理", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/medical/selection/reportSearch",
        name: "selectionReportSearch",
        component: () => import("@/views/science/medical/reportSearch.vue"),
        meta: { title: "选材报告查询", icon: "el-icon-date", usageId: 1 }
      },
      {
        path: "/medical/selection/singleInput",
        name: "selectionSingleInput",
        component: () => import("@/views/science/medical/singleInput.vue"),
        meta: { title: "选材单次录入", icon: "el-icon-date", usageId: 1 }
      },
      {
        path: "/medical/selection/massInput",
        name: "selectionMassInput",
        component: () => import("@/views/science/medical/massInput.vue"),
        meta: { title: "选材批量录入", icon: "el-icon-date", usageId: 1 }
      },
      {
        path: "/medical/selection/dataFix",
        name: "selectionDataFix",
        component: () => import("@/views/science/medical/dataFix.vue"),
        meta: { title: "选材数据修改", icon: "el-icon-date", usageId: 1 }
      }
    ]
  },
  {
    path: "/science/selection/testReport",
    component: Layout,
    alwaysShow: true,
    redirect: "/medical/selection/evaluationReport",
    name: "selectionReport",
    meta: { title: "选材数据分析", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/medical/selection/evaluationReport",
        name: "selectionTestReport",
        component: () => import("@/views/science/medical/testReport.vue"),
        meta: { title: "选材测评报告", icon: "el-icon-date", usageId: 1 }
      },
      {
        path: "/medical/selection/testCollection",
        name: "selectionCollection",
        component: () => import("@/views/science/medical/collection.vue"),
        meta: { title: "选材测试汇总", icon: "el-icon-date", usageId: 1 }
      }
      // {
      //   path: '/medical/selection/tendencyAnalysis',
      //   name: 'selectionTendencyAnalysis',
      //   component: () => import('@/views/science/medical/tendencyAnalysis.vue'),
      //   meta: { title: '选材趋势分析', icon: 'el-icon-date', usageId: 1 ,analysis: true},
      // },
    ]
  },
  // {
  //   path: "/medical/selection/analysisReport",
  //   component: Layout,
  //   redirect: "/medical/selection/analysisReport",
  //   name: "",
  //   meta: { title: "科学选材", icon: "el-icon-s-claim" },
  //   children: [
  //     {
  //       path: "/medical/selection/analysisReport",
  //       name: "selectionAnalysisReport",
  //       component: () => import("@/views/science/medical/analysisReport.vue"),
  //       meta: { title: "选材分析评价报告", icon: "el-icon-date", usageId: 1 }
  //     }
  //   ]
  // },

  // 大纲考核
  {
    path: "/medical/assessment",
    component: Layout,
    alwaysShow: true,
    redirect: "/medical/assessment/massInput",
    name: "assessment",
    meta: { title: "考核报告管理", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/medical/assessment/reportSearch",
        name: "assessmentReportSearch",
        component: () => import("@/views/science/medical/reportSearch.vue"),
        meta: { title: "考核报告查询", icon: "el-icon-date", usageId: 2 }
      },
      {
        path: "/medical/assessment/singleInput",
        name: "assessmentSingleInput",
        component: () => import("@/views/science/medical/singleInput.vue"),
        meta: { title: "考核单次录入", icon: "el-icon-date", usageId: 2 }
      },
      {
        path: "/medical/assessment/massInput",
        name: "assessmentMassInput",
        component: () => import("@/views/science/medical/massInput.vue"),
        meta: { title: "考核批量录入", icon: "el-icon-date", usageId: 2 }
      },
      {
        path: "/medical/assessment/dataFix",
        name: "assessmentDataFix",
        component: () => import("@/views/science/medical/dataFix.vue"),
        meta: { title: "考核数据修改", icon: "el-icon-date", usageId: 2 }
      }
    ]
  },
  {
    path: "/medical/assessmentReport",
    component: Layout,
    alwaysShow: true,
    redirect: "/medical/assessment/testReport",
    name: "assessmentReport",
    meta: { title: "考核数据分析", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/medical/assessment/testReport",
        name: "assessmentTestReport",
        component: () => import("@/views/science/medical/testReport.vue"),
        meta: { title: "考核测评报告", icon: "el-icon-date", usageId: 2 }
      },
      {
        path: "/medical/assessment/collection",
        name: "assessmentCollection",
        component: () => import("@/views/science/medical/collection.vue"),
        meta: { title: "大纲考核汇总", icon: "el-icon-date", usageId: 2 }
      },
      {
        path: "/medical/assessment/tendencyAnalysis",
        name: "assessmentTendencyAnalysis",
        component: () => import("@/views/science/medical/tendencyAnalysis.vue"),
        meta: {
          title: "考核趋势分析",
          icon: "el-icon-date",
          usageId: 2,
          analysis: true
        }
      }
    ]
  },
  {
    path: "/medical/assessment/analysisReport",
    component: Layout,
    redirect: "/medical/assessment/analysisReport",
    name: "",
    meta: { title: "大纲考核", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/medical/assessment/analysisReport",
        name: "assessmentAnalysisReport",
        component: () => import("@/views/science/medical/analysisReport.vue"),
        meta: { title: "考核分析评价报告", icon: "el-icon-date", usageId: 2 }
      }
    ]
  },
  // 疾病筛查
  {
    path: "/medical/filter",
    component: Layout,
    alwaysShow: true,
    redirect: "/medical/filter/massInput",
    name: "filter",
    meta: { title: "疾病报告管理", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/medical/filter/reportSearch",
        name: "filterReportSearch",
        component: () => import("@/views/science/medical/reportSearch.vue"),
        meta: { title: "疾病报告查询", icon: "el-icon-date", usageId: 4 }
      },
      {
        path: "/medical/filter/singleInput",
        name: "filterSingleInput",
        component: () => import("@/views/science/medical/singleInput.vue"),
        meta: { title: "疾病单次录入", icon: "el-icon-date", usageId: 4 }
      },
      {
        path: "/medical/filter/massInput",
        name: "filterMassInput",
        component: () => import("@/views/science/medical/massInput.vue"),
        meta: { title: "疾病批量录入", icon: "el-icon-date", usageId: 4 }
      },
      {
        path: "/medical/filter/dataFix",
        name: "filterDataFix",
        component: () => import("@/views/science/medical/dataFix.vue"),
        meta: { title: "疾病数据修改", icon: "el-icon-date", usageId: 4 }
      }
    ]
  },
  {
    path: "/medical/filterReport",
    component: Layout,
    alwaysShow: true,
    redirect: "/medical/filter/dailyReport",
    name: "filterReport",
    meta: { title: "疾病数据分析", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/medical/filter/dailyReport",
        name: "filterTestReport",
        component: () => import("@/views/science/medical/testReport.vue"),
        meta: { title: "疾病日常报告", icon: "el-icon-date", usageId: 4 }
      },
      // {
      //   path: '/medical/filter/batchCompare',
      //   name: 'filterCollection',
      //   component: () => import('@/views/science/medical/collection.vue'),
      //   meta: { title: '疾病批量对比', icon: 'el-icon-date', usageId: 4 }
      // },
      {
        path: "/medical/filter/tendencyAnalysis",
        name: "filterTendencyAnalysis",
        component: () => import("@/views/science/medical/tendencyAnalysis.vue"),
        meta: {
          title: "疾病趋势分析",
          icon: "el-icon-date",
          usageId: 4,
          analysis: true
        }
      }
    ]
  },
  {
    path: "/medical/filter/analysisReport",
    component: Layout,
    redirect: "/medical/filter/analysisReport",
    name: "",
    meta: { title: "疾病筛查", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/medical/filter/analysisReport",
        name: "filterAnalysisReport",
        component: () => import("@/views/science/medical/analysisReport.vue"),
        meta: { title: "疾病分析评价报告", icon: "el-icon-date", usageId: 4 }
      }
    ]
  },
  // 机能监控
  {
    path: "/medical/monitor",
    component: Layout,
    alwaysShow: true,
    redirect: "/medical/monitor/massInput",
    name: "monitor",
    meta: { title: "机能报告管理", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/medical/monitor/reportSearch",
        name: "monitorReportSearch",
        component: () => import("@/views/science/medical/reportSearch.vue"),
        meta: { title: "机能报告查询", icon: "el-icon-date", usageId: 3 }
      },
      {
        path: "/medical/monitor/singleInput",
        name: "monitorSingleInput",
        component: () => import("@/views/science/medical/singleInput.vue"),
        meta: { title: "机能单次录入", icon: "el-icon-date", usageId: 3 }
      },
      {
        path: "/medical/monitor/massInput",
        name: "monitorMassInput",
        component: () => import("@/views/science/medical/massInput.vue"),
        meta: { title: "机能批量录入", icon: "el-icon-date", usageId: 3 }
      },
      {
        path: "/medical/monitor/dataFix",
        name: "monitorDataFix",
        component: () => import("@/views/science/medical/dataFix.vue"),
        meta: { title: "机能数据修改", icon: "el-icon-date", usageId: 3 }
      }
    ]
  },
  {
    path: "/medical/monitorReport",
    component: Layout,
    alwaysShow: true,
    redirect: "/medical/monitor/dailyReport",
    name: "monitorReport",
    meta: { title: "机能数据分析", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/medical/monitor/dailyReport",
        name: "testReport",
        component: () => import("@/views/science/medical/testReport.vue"),
        meta: { title: "机能日常报告", icon: "el-icon-date", usageId: 3 }
      },
      {
        path: "/medical/monitor/compareReport",
        name: "collection",
        component: () => import("@/views/science/medical/collection.vue"),
        meta: { title: "机能对比报表", icon: "el-icon-date", usageId: 3 }
      },
      {
        path: "/medical/monitor/tendencyAnalysis",
        name: "tendencyAnalysis",
        component: () => import("@/views/science/medical/tendencyAnalysis.vue"),
        meta: {
          title: "机能趋势分析",
          icon: "el-icon-date",
          usageId: 3,
          analysis: true
        }
      }
    ]
  },
  {
    path: "/medical/monitor/analysisReport",
    component: Layout,
    redirect: "/medical/monitor/analysisReport",
    name: "",
    meta: { title: "机能监控", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/medical/monitor/analysisReport",
        name: "monitorAnalysisReport",
        component: () => import("@/views/science/medical/analysisReport.vue"),
        meta: { title: "机能分析评价报告", icon: "el-icon-date", usageId: 3 }
      }
    ]
  },
  {
    path: "/medical/injury_record/view",
    component: Layout,
    redirect: "/medical/injury_record/view",
    name: "",
    meta: { title: "伤病记录管理", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/medical/injury_record/view",
        name: "injury_record",
        component: () => import("@/views/science/injury/injury_record.vue"),
        meta: { title: "伤病记录管理", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/bf/bfView",
    component: Layout,
    redirect: "/bf/bfView",
    name: "",
    meta: { title: "体能测评", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/bf/bfView",
        name: "bfView",
        component: () => import("@/views/science/bfView/bfView.vue"),
        meta: { title: "体能测评录入", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/bf/report/singlePersonReportView",
    component: Layout,
    redirect: "/bf/report/singlePersonReportView",
    name: "",
    meta: { title: "体能测评", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/bf/report/singlePersonReportView",
        name: "singlePersonReportView",
        component: () =>
          import("@/views/science/bfView/singlePersonReportView.vue"),
        meta: { title: "体能测评个人报表", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/bf/report/personTendencyReportView",
    component: Layout,
    redirect: "/bf/report/personTendencyReportView",
    name: "",
    meta: { title: "体能测评", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/bf/report/personTendencyReportView",
        name: "personTendencyReportView",
        component: () =>
          import("@/views/science/bfView/personTendencyReportView.vue"),
        meta: { title: "体能测评趋势报表", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/bf/report/personContrastReportView",
    component: Layout,
    redirect: "/bf/report/personContrastReportView",
    name: "",
    meta: { title: "体能测评", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/bf/report/personContrastReportView",
        name: "personContrastReportView",
        component: () =>
          import("@/views/science/bfView/personContrastReportView.vue"),
        meta: { title: "体能测评对比报表", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/bf/report/analysisReportView",
    component: Layout,
    redirect: "/bf/report/analysisReportView",
    name: "",
    meta: { title: "体能测评", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/bf/report/analysisReportView",
        name: "analysisReportView",
        component: () =>
          import("@/views/science/bfView/analysisReportView.vue"),
        meta: { title: "体能测评评价报告", icon: "el-icon-date" }
      }
    ]
  },
  // 日常训练数据录入
  {
    path: "/daily/dailyTrain",
    component: Layout,
    alwaysShow: true,
    redirect: "/daily/dailyTrain",
    name: "dailyTrain",
    meta: { title: "日常训练数据", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/daily/dailyTrain",
        name: "dailyTrainReportSearch",
        component: () => import("@/views/science/daily/dailyTrain.vue"),
        meta: { title: "日常训练数据录入", icon: "el-icon-date" }
      }
    ]
  },
  // 心里评测
  {
    path: "/examination/view",
    component: Layout,
    alwaysShow: true,
    redirect: "/examination/view",
    name: "examination",
    meta: { title: "心理评测", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/examination/view",
        name: "examinationview",
        component: () => import("@/views/science/examination/index.vue"),
        meta: { title: "心理评测试卷添加", icon: "el-icon-date" }
      },
      {
        path: "/examination/select",
        name: "/examination/PsychologicalTest",
        component: () =>
          import("@/views/science/examination/PsychologicalTest.vue"),
        meta: { title: "心理评测试卷查看", icon: "el-icon-date" }
      }
    ]
  },
  // 心里评测答题
  {
    path: "/examination/examinationpaper",
    component: Mobile,
    alwaysShow: true,
    redirect: "/examination/examinationpaper",
    name: "examinationpaper",
    meta: { title: "心理评测答题", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/examination/examinationpaper",
        name: "examinationExaminationpaper",
        component: () =>
          import("@/views/science/examination/examinationPaper.vue"),
        meta: { title: "心理评测答题", icon: "el-icon-date" }
      }
    ]
  },
  // 体能与专项技术测试
  // ... existing code ...
  {
    path: "/tineng/massInput",
    component: Layout,
    alwaysShow: true,
    redirect: "/tineng/massInput",
    name: "tineng",
    meta: { title: "体能与专项技术管理", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/tineng/reportSearch",
        name: "selectionReportSearch",
        component: () => import("@/views/science/medical/tinengSearch.vue"),
        meta: { title: "体能与专项技术查询", icon: "el-icon-date", usageId: 1 }
      },

      {
        path: "/tineng/massInput",
        name: "tinengMassInput",
        component: () => import("@/views/science/medical/tinengInput.vue"),
        meta: { title: "体能与专项技术录入", icon: "el-icon-date" }
      },

      {
        path: "/tineng/tinengAnalysis",
        name: "tinengAnalysis",
        component: () => import("@/views/science/medical/tinengAnalysis.vue"),
        meta: { title: "体能与专项技术趋势分析", icon: "el-icon-date" }
      },

    ]
  },
  // ... existing code ...
  // 文化教育
  {
    path: "/person/player/studentStatus",
    component: Layout,
    redirect: "/person/player/studentStatus",
    name: "",
    meta: { title: "教育教学", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/person/player/studentStatus",
        name: "educationStudentStatus",
        component: () =>
          import("@/views/player/playerBaseInfo/studentStatus.vue"),
        meta: { title: "学籍档案", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/person/player/cultureScore",
    component: Layout,
    redirect: "/person/player/cultureScore",
    name: "",
    meta: { title: "教育教学", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/person/player/cultureScore",
        name: "educationCultureScore",
        component: () =>
          import("@/views/player/playerBaseInfo/cultureScore.vue"),
        meta: { title: "成绩录入", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/person/player/cultureScoreView",
    component: Layout,
    redirect: "/person/player/cultureScoreView",
    name: "",
    meta: { title: "教育教学", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/person/player/cultureScoreView",
        name: "educationCultureScoreView",
        component: () => import("@/views/education/cultureScoreView.vue"),
        meta: { title: "成绩统计", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/morality/moralityEducation",
    component: Layout,
    redirect: "/morality/moralityEducation",
    name: "",
    meta: { title: "德育管理", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/morality/moralityEducation",
        name: "moralityEducation",
        component: () => import("@/views/education/moralityEducation.vue"),
        meta: { title: "德育教育", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/plan/viewMorality",
    component: Layout,
    redirect: "/plan/viewMorality",
    name: "",
    meta: { title: "德育管理", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/plan/viewMorality",
        name: "viewMorality",
        component: () => import("@/views/education/viewMorality.vue"),
        meta: { title: "德育教育", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/trainPlan/viewUnitPlan",
    component: Layout,
    redirect: "/trainPlan/viewUnitPlan",
    name: "",
    meta: { title: "常规管理撰写", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/trainPlan/viewUnitPlan",
        name: "viewUnitPlan",
        component: () =>
          import("@/views/management/managementCreate/viewUnitPlan.vue"),
        meta: { title: "训练单位训练工作计划", icon: "el-icon-edit-outline" }
      }
    ]
  },
  {
    path: "/trainPlan/viewUnitSummary",
    component: Layout,
    redirect: "/trainPlan/viewUnitSummary",
    name: "",
    meta: { title: "常规管理撰写", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/trainPlan/viewUnitSummary",
        name: "viewUnitSummary",
        component: () =>
          import("@/views/management/managementCreate/viewUnitSummary.vue"),
        meta: { title: "训练单位训练工作总结", icon: "el-icon-edit-outline" }
      }
    ]
  },
  {
    path: "/trainPlan/viewSportTeamYearPlanAndSummary",
    component: Layout,
    redirect: "/trainPlan/viewSportTeamYearPlanAndSummary",
    name: "",
    meta: { title: "常规管理撰写", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/trainPlan/viewSportTeamYearPlanAndSummary",
        name: "viewSportTeamYearPlanAndSummary",
        component: () =>
          import(
            "@/views/management/managementCreate/viewSportTeamYearPlanAndSummary.vue"
          ),
        meta: {
          title: "各运动队年度工作计划及总结",
          icon: "el-icon-edit-outline"
        }
      }
    ]
  },
  {
    path: "/plan/viewRegulation",
    component: Layout,
    redirect: "/plan/viewRegulation",
    name: "",
    meta: { title: "常规管理撰写", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/plan/viewRegulation",
        name: "viewRegulation",
        component: () =>
          import("@/views/management/managementCreate/viewRegulation.vue"),
        meta: { title: "常规管理制度", icon: "el-icon-edit-outline" }
      }
    ]
  },
  {
    path: "/trainPlan/viewHonorReword",
    component: Layout,
    redirect: "/trainPlan/viewHonorReword",
    name: "",
    meta: { title: "常规管理撰写", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/trainPlan/viewHonorReword",
        name: "viewHonorReword",
        component: () =>
          import("@/views/management/managementCreate/viewHonorReword.vue"),
        meta: { title: "公告和通知", icon: "el-icon-edit-outline" }
      }
    ]
  },
  {
    path: "/trainPlan/viewScience",
    component: Layout,
    redirect: "/trainPlan/viewScience",
    name: "",
    meta: { title: "常规管理撰写", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/trainPlan/viewScience",
        name: "viewScience",
        component: () =>
          import("@/views/management/managementCreate/viewScience.vue"),
        meta: { title: "科研工作计划及总结", icon: "el-icon-edit-outline" }
      }
    ]
  },
  {
    path: "/trainPlan/viewAntiDoping",
    component: Layout,
    redirect: "/trainPlan/viewAntiDoping",
    name: "",
    meta: { title: "常规管理撰写", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/trainPlan/viewAntiDoping",
        name: "viewAntiDoping",
        component: () =>
          import("@/views/management/managementCreate/viewAntiDoping.vue"),
        meta: { title: "反兴奋剂计划及总结", icon: "el-icon-edit-outline" }
      }
    ]
  },
  {
    path: "/trainPlan/viewEduWorking",
    component: Layout,
    redirect: "/trainPlan/viewEduWorking",
    name: "",
    meta: { title: "常规管理撰写", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/trainPlan/viewEduWorking",
        name: "viewEduWorking",
        component: () =>
          import("@/views/management/managementCreate/viewEduWorking.vue"),
        meta: { title: "教育计划及总结", icon: "el-icon-edit-outline" }
      }
    ]
  },
  {
    path: "/trainPlan/viewMoralEducation",
    component: Layout,
    redirect: "/trainPlan/viewMoralEducation",
    name: "",
    meta: { title: "常规管理撰写", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/trainPlan/viewMoralEducation",
        name: "viewMoralEducation",
        component: () =>
          import("@/views/management/managementCreate/viewMoralEducation.vue"),
        meta: { title: "德育计划及总结", icon: "el-icon-edit-outline" }
      }
    ]
  },
  {
    path: "/trainPlan/viewEchelonConstruction",
    component: Layout,
    redirect: "/trainPlan/viewEchelonConstruction",
    name: "",
    meta: { title: "常规管理撰写", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/trainPlan/viewEchelonConstruction",
        name: "viewEchelonConstruction",
        component: () =>
          import(
            "@/views/management/managementCreate/viewEchelonConstruction.vue"
          ),
        meta: { title: "梯队建设计划及总结", icon: "el-icon-edit-outline" }
      }
    ]
  },
  {
    path: "/trainPlan/viewTrainDepartmentMiddleLongPlan",
    component: Layout,
    redirect: "/trainPlan/viewTrainDepartmentMiddleLongPlan",
    name: "",
    meta: { title: "常规管理撰写", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/trainPlan/viewTrainDepartmentMiddleLongPlan",
        name: "viewTrainDepartmentMiddleLongPlan",
        component: () =>
          import(
            "@/views/management/managementCreate/viewTrainDepartmentMiddleLongPlan.vue"
          ),
        meta: { title: "训练部门中长期训练规划", icon: "el-icon-edit-outline" }
      }
    ]
  },
  {
    path: "/trainPlan/viewTrainPlanAndSummary",
    component: Layout,
    redirect: "/trainPlan/viewTrainPlanAndSummary",
    name: "",
    meta: { title: "常规管理撰写", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/trainPlan/viewTrainPlanAndSummary",
        name: "viewTrainPlanAndSummary",
        component: () =>
          import(
            "@/views/management/managementCreate/viewTrainPlanAndSummary.vue"
          ),
        meta: { title: "培训规划及总结", icon: "el-icon-edit-outline" }
      }
    ]
  },
  {
    path: "/trainPlan/all4regulationManagement",
    component: Layout,
    redirect: "/trainPlan/all4regulationManagement",
    name: "",
    meta: { title: "常规管理查阅", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/trainPlan/all4regulationManagement",
        name: "all4regulationManagement",
        component: () =>
          import(
            "@/views/management/managementPreview/all4regulationManagement.vue"
          ),
        meta: { title: "常规管理制度查看及修改", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/trainPlan/unitPlan",
    component: Layout,
    redirect: "/trainPlan/unitPlan",
    name: "",
    meta: { title: "常规管理查阅", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/trainPlan/unitPlan",
        name: "unitPlan",
        component: () =>
          import("@/views/management/managementPreview/unitPlan.vue"),
        meta: { title: "训练单位训练工作计划", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/organization/ProvincialDocument",
    component: Layout,
    redirect: "/organization/ProvincialDocument",
    name: "",
    meta: { title: "常规管理查阅", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/organization/ProvincialDocument",
        name: "ProvincialDocument",
        component: () => import("@/views/organization/ProvincialDocument.vue"),
        meta: { title: "上级下发通知", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/trainPlan/unitSummary",
    component: Layout,
    redirect: "/trainPlan/unitSummary",
    name: "",
    meta: { title: "常规管理查阅", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/trainPlan/unitSummary",
        name: "unitSummary",
        component: () =>
          import("@/views/management/managementPreview/unitSummary.vue"),
        meta: { title: "训练单位训练工作总结", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/trainPlan/sportTeamYearPlanAndSummary",
    component: Layout,
    redirect: "/trainPlan/sportTeamYearPlanAndSummary",
    name: "",
    meta: { title: "常规管理查阅", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/trainPlan/sportTeamYearPlanAndSummary",
        name: "sportTeamYearPlanAndSummary",
        component: () =>
          import(
            "@/views/management/managementPreview/sportTeamYearPlanAndSummary.vue"
          ),
        meta: { title: "各运动队年度工作计划及总结", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/regulation/regulation",
    component: Layout,
    redirect: "/regulation/regulation",
    name: "",
    meta: { title: "常规管理查阅", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/regulation/regulation",
        name: "regulation",
        component: () =>
          import("@/views/management/managementPreview/regulation.vue"),
        meta: { title: "常规管理制度", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/regulation/activityHonorReword",
    component: Layout,
    redirect: "/regulation/activityHonorReword",
    name: "",
    meta: { title: "常规管理查阅", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/regulation/activityHonorReword",
        name: "activityHonorReword",
        component: () =>
          import(
            "@/views/management/managementPreview/activityHonorReword.vue"
          ),
        meta: { title: "公告和通知", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/trainPlan/science",
    component: Layout,
    redirect: "/trainPlan/science",
    name: "",
    meta: { title: "常规管理查阅", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/trainPlan/science",
        name: "science",
        component: () =>
          import("@/views/management/managementPreview/science.vue"),
        meta: { title: "科研工作计划及总结", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/trainPlan/antiDoping",
    component: Layout,
    redirect: "/trainPlan/antiDoping",
    name: "",
    meta: { title: "常规管理查阅", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/trainPlan/antiDoping",
        name: "antiDoping",
        component: () =>
          import("@/views/management/managementPreview/antiDoping.vue"),
        meta: { title: "反兴奋剂工作计划及总结", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/trainPlan/eduWorking",
    component: Layout,
    redirect: "/trainPlan/eduWorking",
    name: "",
    meta: { title: "常规管理查阅", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/trainPlan/eduWorking",
        name: "eduWorking",
        component: () =>
          import("@/views/management/managementPreview/eduWorking.vue"),
        meta: { title: "教育工作计划及总结", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/trainPlan/moralEducation",
    component: Layout,
    redirect: "/trainPlan/moralEducation",
    name: "",
    meta: { title: "常规管理查阅", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/trainPlan/moralEducation",
        name: "moralEducation",
        component: () =>
          import("@/views/management/managementPreview/moralEducation.vue"),
        meta: { title: "德育工作计划及总结", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/trainPlan/echelonConstruction",
    component: Layout,
    redirect: "/trainPlan/echelonConstruction",
    name: "",
    meta: { title: "常规管理查阅", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/trainPlan/echelonConstruction",
        name: "echelonConstruction",
        component: () =>
          import(
            "@/views/management/managementPreview/echelonConstruction.vue"
          ),
        meta: { title: "梯队建设工作计划及总结", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/trainPlan/trainDepartmentMiddleLongPlan",
    component: Layout,
    redirect: "/trainPlan/trainDepartmentMiddleLongPlan",
    name: "",
    meta: { title: "常规管理查阅", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/trainPlan/trainDepartmentMiddleLongPlan",
        name: "trainDepartmentMiddleLongPlan",
        component: () =>
          import(
            "@/views/management/managementPreview/trainDepartmentMiddleLongPlan.vue"
          ),
        meta: { title: "训练部门中长期训练规划", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/trainPlan/trainPlanAndSummary",
    component: Layout,
    redirect: "/trainPlan/trainPlanAndSummary",
    name: "",
    meta: { title: "常规管理查阅", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/trainPlan/trainPlanAndSummary",
        name: "trainPlanAndSummary",
        component: () =>
          import(
            "@/views/management/managementPreview/trainPlanAndSummary.vue"
          ),
        meta: { title: "培训规划及总结", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/asset/ground",
    component: Layout,
    redirect: "/asset/ground",
    name: "",
    meta: { title: "资源设施设备", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/asset/ground",
        name: "ground",
        component: () => import("@/views/asset/ground.vue"),
        meta: { title: "训练场馆", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/asset/trainingFacilities",
    component: Layout,
    redirect: "/asset/trainingFacilities",
    name: "",
    meta: { title: "资源设施设备", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/asset/trainingFacilities",
        name: "trainingFacilities",
        component: () => import("@/views/asset/trainingFacilities.vue"),
        meta: { title: "专项训练设施设备", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/asset/medicalFacilities",
    component: Layout,
    redirect: "/asset/medicalFacilities",
    name: "",
    meta: { title: "资源设施设备", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/asset/medicalFacilities",
        name: "medicalFacilities",
        component: () => import("@/views/asset/medicalFacilities.vue"),
        meta: { title: "科研医务设施设备", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/asset/userInstrumentRecord",
    component: Layout,
    redirect: "/asset/userInstrumentRecord",
    name: "",
    meta: { title: "资源设施设备", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/asset/userInstrumentRecord",
        name: "userInstrumentRecord",
        component: () => import("@/views/asset/userInstrumentRecord.vue"),
        meta: { title: "科研设备使用记录", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/asset/educationFacilities",
    component: Layout,
    redirect: "/asset/educationFacilities",
    name: "",
    meta: { title: "资源设施设备", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/asset/educationFacilities",
        name: "educationFacilities",
        component: () => import("@/views/asset/educationFacilities.vue"),
        meta: { title: "教学设施设备", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/asset/gun",
    component: Layout,
    redirect: "/asset/gun",
    name: "",
    meta: { title: "资源设施设备", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/asset/gun",
        name: "gun",
        component: () => import("@/views/asset/gun.vue"),
        meta: { title: "枪支管理", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/asset/dormitory",
    component: Layout,
    redirect: "/asset/dormitory",
    name: "",
    meta: { title: "资源设施设备", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/asset/dormitory",
        name: "dormitory",
        component: () => import("@/views/player/playerBaseInfo/dorm.vue"),
        meta: { title: "宿舍管理", icon: "el-icon-date" }
      }
    ]
  },
  {
    path: "/match/statistics/view",
    component: Layout,
    redirect: "/match/statistics/view",
    name: "",
    meta: { title: "统计管理", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/match/statistics/view",
        name: "matchStatistics",
        component: () => import("@/views/statistics/match.vue"),
        meta: { title: "比赛成绩统计", icon: "el-icon-date", role: [2] }
      }
    ]
  },
  {
    path: "/plan/viewStatistics",
    component: Layout,
    redirect: "/plan/viewStatistics",
    name: "",
    meta: { title: "统计管理", icon: "el-icon-s-claim" },
    children: [
      {
        path: "/plan/viewStatistics",
        name: "planStatistics",
        component: () => import("@/views/statistics/plan.vue"),
        meta: { title: "训练计划统计", icon: "el-icon-date", role: [2] }
      }
    ]
  }
];

const createRouter = () =>
  new Router({
    // mode: 'history',
    mode: "hash", // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: [...asyncRouters, ...constantRoutes]
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
